export default __webpack_public_path__ + "static/media/837.73468ee3.png";